import { render } from "./Highlightable.vue?vue&type=template&id=eb0503cc&scoped=true"
import script from "./Highlightable.vue?vue&type=script&lang=js"
export * from "./Highlightable.vue?vue&type=script&lang=js"

import "./Highlightable.vue?vue&type=style&index=0&id=eb0503cc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb0503cc"]])

export default __exports__